import { type AxiosError } from 'axios';

export default function isAxiosError(v: unknown): v is AxiosError {
  return (
    typeof v === 'object' &&
    v !== null &&
    'isAxiosError' in v &&
    v.isAxiosError === true
  );
}
